import en from './en.json';
import hi from './hi.json';
import mr from './mr.json';
import fa from './fa.json';
import fr from './fr.json';
import es from './es.json';
import ar from './ar.json';
import ur from './ur.json';
import or from './or.json';
import kok from './kok.json';

const locales = {
  en,
  hi,
  mr,
  fa,
  fr,
  es,
  ar,
  ur,
  or,
  kok
};

export default locales;

export const localeKeys = Object.keys(locales)



// WEBPACK FOOTER //
// ./src/i18n/index.js